import { useEffect, useState } from 'react';

import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';

import { CustomStepContentInterface } from '../../../Models/Common/CustomViewsInterfaces';

import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';

import CustomButton from '../CustomButton';

const StepContentContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    padding: 20px;

    .stepHeader {
        font-size: 1.09375rem;
        font-weight: 600;
    }

    .stepSubHeader {
        font-size: 0.825rem;
        font-weight: 500;
        color: #878a99;
    }

    .childrenContainer {
        width: 100%;
        margin: 20px 0px 0px 0px;
    }

    .actionButtonsContainer {
        display: flex;
        justify-content: space-between;
        margin: 20px 0px 0px 0px;

        .nextBtn {

        }
    }
`;

export default function CustomStepContent(props: CustomStepContentInterface) {
    let isDarkMode = LocalStorageHelper.isDarkMode();
    let prevStep = props?.stepperItems?.find((step: any) => step.id == (props?.selectedStep?.id - 1));
    let nextStep = props?.stepperItems?.find((step: any) => step.id == (props?.selectedStep?.id + 1));

    return <StepContentContainer>
            {props?.stepHeader && <Typography className="stepHeader" color='primaryText'>{props?.stepHeader ?? ""}</Typography>}
            {props?.stepSubHeader && <Typography className="stepSubHeader">{props?.stepSubHeader ?? ""}</Typography>}
            <div className="childrenContainer">
                {props?.children ?? ""}
            </div>

            <div className="actionButtonsContainer">
                {(!props.hideprevStep && prevStep?.id && nextStep?.id) ? <CustomButton
                    className="prevBtn"
                    btnType={ButtonType.CANCEL}
                    title={'Back to ' + prevStep?.btnName ?? ""} 
                    startIcon={<IconArrowLeft />}
                    // isRoundedCorner={true}
                    onClick={(e: any) => {
                        if(props?.setselectedStep) {
                            props.setselectedStep(prevStep);
                        }
                    }} /> : <div />}
                
                {!props.hideprevStep && nextStep?.id && <CustomButton
                    className="nextBtn"
                    btnType={ButtonType.PRIMARY}
                    title={nextStep?.btnName ?? ""} 
                    endIcon={<IconArrowRight />}
                    onClick={async (e: any) => {
                        let proceed: any = !props?.validateStep;

                        if(props?.validateStep) {
                            proceed = await props.validateStep(e);
                        }

                        if(props?.setselectedStep && proceed) {
                            props.setselectedStep(nextStep);
                        }
                    }} />}
            </div>
        </StepContentContainer>
}
